import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import roundReply from '@iconify/icons-ic/round-reply';
import { useNavigate, useParams } from 'react-router-dom';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { styled } from '@material-ui/core/styles';
import { Box, Link, Tooltip, Typography, IconButton } from '@material-ui/core';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// utils
import createAvatar from '../../../utils/createAvatar';
import { fDateTimeSuffix } from '../../../utils/formatTime';
//
import { MAvatar, MHidden } from '../../@material-extend';
import { setContactSelected } from '../../../redux/slices/selected';
import { useDispatch } from '../../../redux/store';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: 60,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  justifyContent: 'space-between',
  backgroundColor: "#d0f2ff"
}));

// ----------------------------------------------------------------------

MailDetailsToolbar.propTypes = {
  mail: PropTypes.object
};

export default function MailDetailsToolbar({ contact, ...other }) {
  const navigate = useNavigate();
  const { systemLabel, customLabel } = useParams();
  const baseUrl = PATH_DASHBOARD.mail.root;
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(setContactSelected(null))
  };
  const mail = {
    "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
    "labelIds": [
      "id_promotions",
      "id_forums"
    ],
    "folder": "promotions",
    "isImportant": true,
    "isStarred": true,
    "isUnread": true,
    "subject": "Apply These 7 Secret Techniques To Improve Event",
    "message": "Assumenda nam repudiandae rerum fugiat vel maxime.",
    "createdAt": "2023-04-06T08:57:46.071Z",
    "files": [],
    "from": {
      "name": "Jayvion Simon",
      "email": "mailto:nannie_abernathy70@yahoo.com",
      "avatar": "/static/mock-images/avatars/avatar_1.jpg"
    },
    "to": [
      {
        "name": "Jaydon Frankie",
        "email": "mailto:demo@minimals.cc",
        "avatar": null
      }
    ]
  }
  return (
    <RootStyle {...other}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {/* <Tooltip title="Back">
          <IconButton onClick={handleBack}>
            <Icon icon={arrowIosBackFill} width={20} height={20} />
          </IconButton>
        </Tooltip> */}

        <MAvatar alt={mail?.from?.name} src={mail?.from?.avatar} color={createAvatar(mail?.from?.name)?.color}>
          {createAvatar(mail?.from?.name)?.name}
        </MAvatar>

        <Box sx={{ ml: 2 }}>
          <Typography display="inline" variant="subtitle2">
            {contact?.name}
          </Typography>
          {/* <Link variant="caption" sx={{ color: 'text.secondary' }}>
            &nbsp; {`<${contact.email}>`}
          </Link> */}
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
            Quản lí  bởi:&nbsp;
            <Link color="inherit" key={contact?.email}>
              {contact?.assigned_by_name}
            </Link>
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <MHidden width="smDown">
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {contact?.created_at}
          </Typography>
          {/* <Tooltip title="Reply">
            <IconButton>
              <Icon icon={roundReply} width={20} height={20} />
            </IconButton>
          </Tooltip> */}
        </MHidden>
        {/* <Tooltip title="More options">
          <IconButton>
            <Icon icon={moreVerticalFill} width={20} height={20} />
          </IconButton>
        </Tooltip> */}
      </Box>
    </RootStyle>
  );
}
